/*
 * @Author: COCO
 * @Date: 2018-01-17 20:58:53
 * @Last Modified by: COCO
 * @Last Modified time: 2019-03-05 11:13:24
 * 整个页面头部组件
 */
<template>
  <div class="header">
    <!-- <div class="header-title">热点掘金</div> -->
    <div class="header-title"><img v-show="windowClientType()"
           src="//u.thsi.cn/imgsrc/neican/a8202d891e086fc35eebe9d6b8185a05.png"><span v-show="!windowClientType()">热点掘金</span></div>
    <div v-for='(item,index) in items'
         :key='item'
         class="header-tab"
         @click='tabclick(index)'
         :class='{active:index==selectStatus}'
         v-if="showStatus(index)">{{item}}</div>
    <div class="back"
         v-if="showReturn">
      <a :href="l2HomeUrl">返回Level-2首页</a>
    </div>
    <div class="back"
         v-if="fromFree">
      <a href="#"
         @click="returnFree">返回免费版</a>
    </div>
    <!-- <div class="back"
         v-if="showFeedback">
      <a href="#"
         @click="feedback">反馈</a>
    </div> -->
    <div class="nav-btn-list">
      <!-- <p class="nav-btn-lister">
          使用说明 <span class="nav-btn-circle">?</span>
        </p> -->
      <p class="nav-btn-lister"
         id="sysm_btn">关于产品 <span class="nav-btn-circle">?</span></p>
      <!-- <p class="nav-btn-lister"
         id="mzsm_btn">免责声明 <span class="nav-btn-circle">i</span></p> -->
      <div class="nav-mzsz"
           id="mzsm_content"
           style="display:none;">
        <p>以上功能仅供参考，不作投资依据，股市有风险，操作需谨慎。</p>
        <p>同花顺云软件有限公司免责声明。</p>
        <p>客服热线：952555</p>
      </div>
      <div class="nav-con-inner"
           id="sysm_content"
           style="display:none;">
        <!-- <p class="cursor"
           @click="showHowUse">使用说明</p> -->
        <p class="cursor"
           @click="feedback">用户反馈</p>
      </div>
    </div>
    <!-- <span @click="openwindow">test</span> -->
    <a href="###"
       class="win-icon btn-ret-embed"
       title="返回内嵌窗口"
       id="retEmbed"
       v-if="clientType != 0"
       style="position: absolute;top: 10px;right: 18px;"></a>
    <a href="###"
       class="win-icon btn-pop-win"
       title="弹出窗口"
       id="popWin"
       v-if="clientType != 0"
       style="position: absolute;top: 10px;right: 18px;"></a>
  </div>
</template>
<script>
import router from '@/router/index.js';
import hoverEvent from './hoverEvent.js';

export default {
  created() {
    const self = this;
    eventBus.$on('url', self.handle); //点击板块地图时将板块详情置为选中状态
    if (window.location.href.indexOf('blockDetail') != -1) {
      self.selectStatus = 1;
    } else if (window.location.href.indexOf('hotAnalysis') != -1) {
      self.selectStatus = 2;
    } else {
      self.selectStatus = 0;
    }
    if (window.location.href.indexOf('fromfree') !== -1) {
      self.fromFree = true;
    }
  },

  mounted() {
    const s = this;
    this.f = new Feedback({
      id: 106, // 大研究
      showContact: true,
      titleBg: '#b62a29',
      borderColor: '#b62a29',
      contentLimit: 300
    });
    API.use({
      method: 'Quote.getHxCurPageID',
      success(result) {
        if (result == '5716') {
          s.showReturn = true;
        }
      }
    });
    API.use({
      method: 'Util.getHxProduct',
      success: res => {
        if (Number(res) === 1) {
          //大研究
          s.showFeedback = true;
        }
        s.clientType = res;
      },
      notClient: () => {
        s.showFeedback = true;
      },
      error: () => {}
    });
    //免责声明
    const hover1 = new hoverEvent();
    const hover2 = new hoverEvent();
    // hover1.init('mzsm_btn', 'mzsm_content');
    hover2.init('sysm_btn', 'sysm_content');
    this.init();
  },

  beforeDestroy() {
    // console.log('销毁了url');
    eventBus.$off('url', self.handle);
  },
  data() {
    return {
      selectStatus: 0,
      items: ['市场概览', '板块详情', '热点剖析'],
      showReturn: false,
      showFeedback: false,
      clientType: -1,
      f: null,
      fromFree: false,
      l2HomeUrl: `//l2.${window.dynamicDomain}/index/homepage/dist/index.html`,
    };
  },
  methods: {
    windowClientType() {
      if (window.clientType === 2) {
        return true;
      } else {
        return false;
      }
    },
    handle(val) {
      this.selectStatus = val;
    },
    init() {
      const self = this;
      if (self._getWinFromURL() != -1) {
        //弹窗
        document.getElementById('retEmbed').style.display = 'block';
        document.getElementById('popWin').style.display = 'none';
      } else {
        //内嵌
        document.getElementById('retEmbed').style.display = 'none';
        document.getElementById('popWin').style.display = 'block';
        // $("#retEmbed").hide();
        // $("#popWin").show();
      }
      document.getElementById('popWin').addEventListener('click', function() {
        self._popWin();
      });
      document.getElementById('retEmbed').addEventListener('click', function() {
        self._retEmbed();
      });
      if(self.windowClientType()){
        self.items[0]='今日热点';
      }
    },
    _popWin() {
      API.use({
        method: 'Util.openURL2',
        data: {
          url: this._openWin(window.location.href.replace('###', '').replace(/\%25/g, '%')),
          mode: 6,
          useCef: true
        }
      });
    },
    _openWin(link) {
      if (!link) {
        return link;
      }
      if (link.indexOf('?') >= 0) {
        link += '&win=1';
      } else {
        link += '?win=1';
      }
      return link;
    },
    _retEmbed() {
      const self = this;
      let id = 8763; //这个是金融大师的页面id
      let name = '热点轮动';
      API.use({
        method: 'Util.getHxProduct',
        success: res => {
          if (res == 1) {
            id = 4918;
            name = '产业热点';
          }
          const data = {
            id,
            name,
            url: location.href
              .replace('?win=1', '')
              .replace('&win=1', '')
              .replace('###', '')
          };
          API.use({
            method: 'Quote.changeContainerUrl',
            data,
            success() {
              API.use({ method: 'external.closeWebDlg' });
            }
          });
        }
      });
    },
    _getWinFromURL() {
      const url = window.location.href.replace(/\?/, '#').replace(/\&/g, '#');
      const reg = new RegExp('(^|#)win=([^&]*)(&|$)');
      const r = url.match(reg);
      if (r != null) {
        return unescape(r[2]);
      } else {
        return -1;
      }
    },
    returnFree() {
      API.use({
        method: 'Quote.switchPage',
        data: {
          id: 4833
        }
      });
    },
    showStatus(index) {
      if (index == 1 && window.clientType === 2) {
        return false;
      } else if (index == 2 && window.clientType !== 2) {
        return false;
      } else {
        return true;
      }
      // return true;
    },
    tabclick(index) {
      const self = this;
      if (index == self.selectStatus) {
        return;
      }
      if (index == 0) {
        router.push('/marketCondition');
      } else if (index == 1) {
        router.push('/blockDetail');
      } else if (index == 2) {
        router.push('/hotAnalysis');
        TA.log({ id: 'jrds_hottrack_wdh_20180815_1' });
      }
      eventBus.$emit('tab', index);
      eventBus.$emit('showSelectBlock', index);
      self.selectStatus = index;
    },
    feedback() {
      const that = this;
      const feedbackInstance = new PcTongyiFeedback();
      feedbackInstance.run({
        id: 106,
        onError: () => {
          oldHandler();
        }
      });
      function oldHandler() {
        that.f.show();
      }
    },
    openwindow() {
      this.$eventBus.$emit('openWindow', 'marketSentiment');
    }
  }
};
</script>
<style>
.header {
  box-sizing: border-box;
  background-color: #0e0e0e;
  height: 36px;
  color: white;
  line-height: 36px;
}
.white .header {
  background-color: #434343;
}
.header-title {
  float: left;
  font-size: 16px;
  font-family: '微软雅黑';
  font-weight: bold;
  margin-left: 20px;
  margin-right: 60px;
  text-align: center;
}

.header-tab {
  width: 100px;
  height: 34px;
  float: left;
  font-size: 14px;
  text-align: center;
  position: relative;
}

.header-tab:hover {
  cursor: pointer;
}

.header .active {
  background-color: #1b1b1b;
  border-bottom: 2px solid #db1919;
  font-weight: bold;
}

.back {
  font-size: 15px;
  text-align: right;
  /* font-family: '宋体'; */
  padding-right: 210px;
}

.back a {
  padding-right: 25px;
  color: white;
}
.nav-btn-list {
  /* width: 198px; */
  height: 16px;
  line-height: 16px;
  position: absolute;
  top: 10px;
  right: 40px;
  color: #9c9c9c;
  font-size: 12px;
}
.nav-btn-lister {
  float: left;
  padding: 0 10px;
  margin: 0 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.nav-btn-lister:not(:last-child) {
  border-right: 1px solid #9c9c9c;
}
.nav-btn-circle {
  display: inline-block;
  width: 12px;
  height: 12px;
  border: 1px solid #9c9c9c;
  text-align: center;
  line-height: 12px;
  border-radius: 12px;
  color: #9c9c9c;
  margin-left: 6px;
}
.nav-mzsz {
  width: 360px;
  padding: 10px 10px;
  background: #212829;
  border-radius: 5px;
  position: absolute;
  top: 20px;
  right: 20px;
  line-height: 18px;
  text-align: left;
  z-index: 1000;
}
.nav-mzsz p,
.nav-con-inner p {
  padding: 0;
  margin: 0;
}
.nav-con-inner {
  width: 73px;
  padding: 5px 10px;
  background: #212829;
  border-radius: 5px;
  position: absolute;
  top: 20px;
  /* right: 118px; */
  line-height: 18px;
  text-align: left;
  z-index: 1000;
  cursor: pointer;
}

.win-icon {
  background: url(//i.thsi.cn/images/level2/hottrack/20190410/sprite.png) no-repeat;
  width: 13px;
  height: 10px;
}
.btn-pop-win {
  background-position: -55px 0;
  width: 13px;
  height: 14px;
}
.btn-ret-embed {
  background-position: -38px 0;
  width: 12px;
  height: 14px;
}
</style>




// WEBPACK FOOTER //
// src/components/header/rdhead.vue